// @flow strict

import * as React from 'react';
import PageContentBlock from '../../internal/PageContentBlock';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import Table from './internal/Table';

type TableComponentPropsType = {|
  title: string,
  intro: string,
  columns: Array<string>,
  rows: Array<Array<?string>>,
|};

export default (props: TableComponentPropsType) => {
  const columns = React.useMemo(
    () =>
      props.columns.map((c, i) => ({
        Header: c,
        accessor: `${i}`,
        width: 120,
        minWidth: 100,
      })),
    [props.columns],
  );

  // $FlowFixMe
  const rows = React.useMemo(() => props.rows.map(r => Object.assign({}, r)), [props.rows]);
  return (
    <PageContentBlock
      title={props.title}
      intro={props.intro}
      background="DefaultContrast"
      smallPadding
    >
      <div className={styles.container}>
        <Table columns={columns} data={rows} />
      </div>
    </PageContentBlock>
  );
};
